import * as gateway from 'sfx-web-contract';
import { COMMUNICATION_SERVICE, ICommunicationService } from '../../communication';
import { ILogAdapterService } from './log-adapter.interface';
import { IMonitoringBody } from '../../../interfaces';
import { inject, injectable } from 'inversify';
import { logEncode } from './log-adapter.utils';

@injectable()
export class LogAdapterService implements ILogAdapterService {

    @inject(COMMUNICATION_SERVICE) private readonly communicationSrv: ICommunicationService;

    send(logs: IMonitoringBody): void {
        this.communicationSrv.send(
            logEncode(logs),
            gateway.MessageTypes.Log,
        );
    }
}
